import { RootState } from "@/redux/store";
import { useValidateBulkUploadUserMutation } from "@/services";
import { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "@/components/Toast";
import { StepsProps } from "../types";
import { setBulkUploadDtl } from "@/redux/slices";

const useStep1 = ({onNextStepClick}: StepsProps) => {
  const dispatch = useDispatch();
  const [file, setFile] = useState<any>(null);
  const communityData = useSelector(
    (state: RootState) => state.currentData.communityData
  );

  const onDrop = useCallback((acceptedFiles: any) => {
    // Do something with the files
    if (acceptedFiles.length) {
      setFile(acceptedFiles[0]);
    }
  }, [])

  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    onDrop,
    multiple: false,
    accept: {
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      'application/vnd.ms-excel': ['.xls'],
      'text/csv': ['.csv'] 
    }
  })
  
  const { mutate: validateUpload, isPending: isUploadPending } =
    useValidateBulkUploadUserMutation({
      onError: (error?: any) => {
        toast.error(
          typeof error?.response?.data?.message === "string"
            ? error?.response?.data?.message
            : "Something went wrong"
        );
        return error?.response?.data?.message;
      },
      onSuccess: (data: any) => {
        dispatch(setBulkUploadDtl({...data?.data?.data}))
        onNextStepClick?.();
        // const {errorCount, successCount, logFilePath, warningCount} = data?.data?.data || {};

        // if (errorCount) {
        //   if (logFilePath) {
        //     window.open(logFilePath, "_blank");
        //   } else {
        //     toast.success(data?.data?.message, {
        //       className: "!bg-red-600 !text-white",
        //     });
        //   }
        // }
        // if (successCount) {
        //   if (!errorCount) {
        //     toast.success("User Added Successfully", {
        //       className: "!bg-green-600 !text-white",
        //     });
        //     setFile(null);
        //   }
        // }
      },
    });

  const onValidate = () => {
    validateUpload({
      communityId: communityData?.communityId,
      data: {
        file
      }
    })
  }

  return {
    getRootProps,
    getInputProps,
    isDragActive,
    isUploadPending,
    file,
    onValidate
  }
}

export default useStep1;